/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */

export type GetOrdersStatus = typeof GetOrdersStatus[keyof typeof GetOrdersStatus];


export const GetOrdersStatus = {
  created: 'created',
  confirmed: 'confirmed',
  preparing: 'preparing',
  shipped: 'shipped',
  completed: 'completed',
  canceled: 'canceled',
} as const;
